<template>
    <div>
        <div class="search-wrapper" v-bind:class="{ active: searchOpen }">
            <div class="input-holder">
                <input type="text" class="search-input" placeholder="Tapez pour rechercher" @keypress.enter="$emit('search',search)"/>
                <button class="search-icon" v-on:click="searchOpen = !searchOpen"><span/></button>
            </div>
            <button class="close" v-on:click="searchOpen = !searchOpen"/>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      searchOpen: false,
    }
  },
}
</script>

